import {useMutation} from "@tanstack/react-query";

import {convertLeadToClientMutationOptions} from "./convert-lead-to-client.mutation-options";

export function useConvertLeadToClient() {
  return useMutation(convertLeadToClientMutationOptions());
}
